import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SelectedCompanyService } from '@src/app/services/selected-company-service/selected-company.service';
import { ZonarUiMapModule } from '@zonar-ui/zonar-ui-map';

@Component({
  selector: 'app-map-wrapper',
  standalone: true,
  imports: [CommonModule, ZonarUiMapModule],
  templateUrl: './map-wrapper.component.html',
  styleUrls: ['./map-wrapper.component.scss']
})
export class MapWrapperComponent {
  companyId$ = this.companyService.getCurrentCompany();

  constructor(
    private companyService: SelectedCompanyService,
  ) { }
}
